module.exports = __webpack_public_path__ + "img/overview-private2.a8907772.png";